import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "../components/ui/breadcrumb";

interface BreadcrumbLinkItem {
  label: string;
  href?: string;
  onClick?: () => void;
  icon?:React.ReactNode
}

interface BreadcrumbHeaderProps {
  title?: string; // 👈 Customizable page title
  breadcrumbs?: BreadcrumbLinkItem[];
  onBack?: () => void;
  onNext?: () => void;
  onPrev?: () => void;
  paragraph?:string,
  className?:string
  titleIcon?:React.ReactNode
  titleClassName?:string
}

export function BreadcrumbHeader({
  title,
  breadcrumbs,
  onBack,
  onNext,
  onPrev,
  paragraph,
  className,
  titleIcon,
  titleClassName
}: BreadcrumbHeaderProps) {
  return (
    <div className={`${className?className:'mb-6'}`}>
      {/* Breadcrumb Trail */}
      <div className="mb-3">
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbs?.map((crumb, index) => (
              <BreadcrumbItem key={index}>
                {crumb.href || crumb.onClick ? (
                  <div className="flex items-center gap-2">
                    {crumb.icon && <span className="mr-1">{crumb.icon}</span>}
                  <BreadcrumbLink
                    href={crumb.href ?? "#"}
                    className="text-gray-600 hover:text-gray-900"
                    onClick={crumb.onClick}
                  >
                    {crumb.label}
                  </BreadcrumbLink>
                  </div>
                ) : (
                  <BreadcrumbPage className="text-gray-900">
                    {crumb.label}
                  </BreadcrumbPage>
                )}
                {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
              </BreadcrumbItem>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      {/* Title + Navigation */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
             {onBack && breadcrumbs && breadcrumbs?.length > 1 && (
  <Button
    variant="ghost"
    onClick={onBack}
    className="flex items-center gap-2 text-gray-600 hover:text-gray-900 !px-0"
  >
    <ArrowLeft className="w-4 h-4" />
    {`Back to ${breadcrumbs && breadcrumbs[breadcrumbs?.length - 2]?.label}`}
  </Button>
)}
          {title && (<div className={titleIcon?"flex justify-center gap-2 items-center":""}>
            {titleIcon && <span>{titleIcon}</span>}
            <h2 className={titleClassName?titleClassName:`text-xl font-semibold text-gray-900`}>{title}</h2>
            </div>
          )}
        </div>

        
      </div>
      <div className="flex gap-y-4">
         <p>{paragraph}</p>
    
        </div>
    </div>
  );
}
